import React from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  FaPhone,
  FaPaperPlane,
  FaEnvelopeOpenText,
  FaPoundSign,
  FaClipboardList,
} from "react-icons/fa";
import "../WhyChoose/WhyChoose.css";

const WhyChoose = () => {
  const { id } = useParams();
  const location = useLocation();

  // ✅ Only show "Check Our Price" when path starts with /holidays/
  const showPriceCard = location.pathname.startsWith("/holidays/");

  const handleScroll = () => {
    const targetId = id === "kenya-safari" ? "pr-d" : "pr-s";
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      console.warn(`Element with id ${targetId} not found`);
    }
  };

  const handleCall = () => {
    window.location.href = "tel:02038852600";
  };

  const handleNavigate = () => {
    const formSection = document.getElementById("h-fh");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#h-fh";
    }
  };

  const handleEmail = () => {
    const subject = encodeURIComponent("Tripmart Travel Enquiry");
    const body = encodeURIComponent(
      "Hi Tripmart Team,\n\nI’d like to know more about your latest travel deals and offers.\nPlease share the details.\n\nThanks,"
    );
    window.location.href = `mailto:info@tripmart.co.uk?subject=${subject}&body=${body}`;
  };

  return (
    <section className="why-choose-container-wc">
      <div className="left-side-wc">
        <h2 className="heading-wc">Why choose us?</h2>
        <ul className="list-wc">
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> Your Trustworthy Travel Partner
          </li>
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> No Fee on Credit & Debit Card
          </li>
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> Flexible Payment Options & Low
            Deposits
          </li>
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> Exclusive Deals for Hundreds of
            Destinations
          </li>
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> Custom Made Holidays Crafted by
            Seasoned Travel Professionals
          </li>
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> Discover Unbeatable Discounts
            and Best Value for Money Offerings
          </li>
          <li className="list-item-wc">
            <FaPaperPlane className="icon-wc" /> We are open 24 hours a day, 7
            days a week
          </li>
        </ul>
      </div>

      <div className="right-side-wc">
        <div className="card-wc" onClick={handleCall}>
          <FaPhone className="card-icon-wc" />
          <div className="card-content-wc">
            <h3 className="card-title-wc">Call Us (02038852600)</h3>
            <p className="card-text-wc">
              For Bookings & Latest Offers Call Our Experts Now
            </p>
          </div>
        </div>

        <div className="card-wc" onClick={handleNavigate}>
          <FaClipboardList className="card-icon-wc" />
          <div className="card-content-wc">
            <h3 className="card-title-wc">Enquire Now</h3>
            <p className="card-text-wc">
              Fill out the form to get personalized travel deals and quotes.
            </p>
          </div>
        </div>

        <div className="card-wc" onClick={handleEmail}>
          <FaEnvelopeOpenText className="card-icon-wc" />
          <div className="card-content-wc">
            <h3 className="card-title-wc">Deals in your inbox</h3>
            <p className="card-text-wc">
              Email us to get the best travel deals and personalized offers.
            </p>
          </div>
        </div>

        {/* ✅ Conditionally render only when on /holidays/ route */}
        {showPriceCard && (
          <div className="card-wc" onClick={handleScroll}>
            <FaPoundSign className="card-icon-wc" />
            <div className="card-content-wc">
              <h3 className="card-title-wc">Check Our Price</h3>
              <p className="card-text-wc">
                See the best available rates for your next holiday.
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default WhyChoose;
